import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  callAPI,
  IRoleMain,
  Method,
  toTitleCase,
  TransactionPages,
  LoacalVariables,
  getLocalValue
} from "../../commonFunctions/CommonFunctions";
import WSDataGrid, {
  BulkAction,
  IColumns
} from "../../Components/DataGrid/WSDataGrid";
import { openPopUp } from "../../Components/Dialog/OpenNewModal";
import { IMetaData } from "../../Components/Dialog/WSCommonDialog";
import { IRows } from "../../Components/Filter/WSFilterComponent";
import { HeaderList } from "../../Components/Header/HeaderList";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import clientconfig from "../../Config/clientConfig.json";
import { resetDataComponent } from "../../StateManagement/actions";
import { UpdateStatus } from "./UpdateStatus";
import { getPermissions } from "../../commonFunctions/PermissionManger";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import LoadingOverlay from "./Compo/LoadingOverlay";
import { PrintData } from "./NewWalkInOrder/WalkInForm";
import { WSIcons } from "../../commonFunctions/iIcons";
import ConfirmationPopup from "../../Components/Confirmation/Confirmation";

export type OrderItem = {
  productId: string;
  productName: string;
  serviceName: string;
  quantity: number;
  itemTag: string;
};

export type GroupedProduct = {
  productId: string;
  productName: string;
  services: string[];
  quantity: number;
  itemTag: string;
};

interface Order {
  orderId: string;
  status: string;
}

export type CompanyData = {
  id: string;
  name: string;
  owner: string;
  location: string;
  contactNumber: string;
  logoUrl: string | null;
  addressLine1: string;
  addressLine2: string;
  state: string;
  city: string;
  pincode: string;
  logo: string | null;
  createdDate: string;
  updatedDate: string;
};

export const OrderListUI: React.FC<any> = () => {
  const { edit, add, view, changestatus, exports } = getPermissions(
    TransactionPages.OrdersList,
    IRoleMain.Transactions
  );
  const { showMessage } = useSnackbar();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [orderId, setOrderID] = useState<any>(null);
  const [bulkOrderId, setBulkOrderID] = useState<any>(null);
  const [selectedId, setSelectedId] = useState<any>(null);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [totalCount, setTotalCount] = useState<any>();
  const [filterChanged, setFilterChanged] = useState<any>(false);

  const [loading, setLoading] = useState<any>(false);
  const [selectedOrderIds, setSelectedOrderIds] = useState<Order[]>([]);
  const [company, setCompany] = useState<CompanyData | null>(null);

  const franchiseId = getLocalValue(LoacalVariables.FranchiseId);

  useEffect(() => {
    const fetchCompany = async () => {
      const response = await callAPI(
        "franchises",
        Method.GET,
        null,
        franchiseId
      );
      console.log("response franchise", response);
      setCompany(response.data);
    };

    fetchCompany();
  }, []);

  const columns: IColumns[] = [
    {
      header: "Select All",
      fieldName: "checkbox",
      type: "checkbox"
    },

    {
      header: "Order#",
      fieldName: "orderNumber",
      type: "default",
      sortable: true,
      sortKey: "OrderNumber"
    },
    {
      header: "Name",
      fieldName: "customerName",
      type: "default"
    },

    { header: "Phone", fieldName: "phoneNumber", type: "default" },
    { header: "Is Home Delivery", fieldName: "homeDelivery", type: "default" },
    { header: "Status", fieldName: "orderStatus", type: "status" },
    {
      header: "Ordered On",
      fieldName: "orderDate",
      type: "date",
      sortable: true
    },
    {
      header: "Expected Delivery",
      fieldName: "deliveryDate",
      type: "date",
      sortable: true
    },
    {
      header: "Total Price",
      fieldName: "finalAmount",
      type: "default"
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [
        edit ? "Edit" : undefined,
        "Delete",
        changestatus ? "Change Status" : undefined,
        // printtag ? "Print Tag" : undefined
        "Print Tag",
        "Generate Bill"
      ],
      fieldCompare: {
        fieldName: "orderStatus",
        ValueCheck: { value: "Paid", actionCheck: "Change Status,Edit" }
      },
      hideAction: {
        actionName: [
          {
            fieldName: "orderStatus",
            values: ["Completed"],
            hideAction: ["Edit"]
          },
          {
            fieldName: "orderStatus",
            values: ["Paid"],
            hideAction: ["Change Status,Edit"]
          }
        ]
      },
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];

  const handleClick = () => {
    navigate(`/new-walk-in-order`);
  };
  const filterRows: IRows[] = [
    {
      label: "Order#",
      fieldName: "OrderNumber",
      type: "text",
      operator: "like",
      rowDivision: 6
    },
    {
      label: "Customer Name",
      fieldName: "CustomerName",
      type: "text",
      operator: "like",
      rowDivision: 6
    },

    {
      label: "Phone Number",
      fieldName: "PhoneNumber",
      type: "text",
      operator: "like",
      rowDivision: 6
    },
    {
      label: "Status",
      fieldName: "OrderStatus",
      type: "radio",
      operator: "eq",
      align: "horizontal",
      options: clientconfig.filtterStatusConfig.staticOptionData,
      rowDivision: 12
    }
  ];

  const source = {
    url: "orders/search",
    page: 1,
    pageSize: 10,
    filter: [
      {
        field: "FranchiseId",
        operator: "eq",
        value: franchiseId
      }
    ],
    sort: [{ field: "OrderNumber", direction: "desc" }]
  };
  const transFormData = (data: any, totalCount: any) => {
    setTotalCount(totalCount);
    if (data && data?.length > 0) {
      data?.map((item: any) => {
        item.homeDelivery = item?.isHomeDelivery ? "Yes" : "No";
        item.status = toTitleCase(item.orderStatus);
      });
      return data;
    }
  };
  const handleStatus = async (data: any) => {
    try {
      // setLoading(true);
      const response: any = await saveData(data);
      setOrderID(null);

      if (response && response?.message) {
        dispatch(resetDataComponent("ordersGrid"));
        showMessage(
          response.message,
          response.success === true ? "success" : "error"
        );
      }
    } catch (e: any) {
      showMessage(e.error);
    } finally {
      setOrderID(null);
      // setLoading(false);
    }
  };

  // When performing the status change
  const handleBulkStatus = async (data: any) => {
    try {
      const responses = await Promise.all(
        selectedOrderIds.map(async (order) => {
          const request = {
            newStatus: data?.newStatus,
            updatedBy: "Test"
          };
          return callAPI(`orders/${order.orderId}/status`, Method.PUT, request);
        })
      );

      setBulkOrderID(null);

      responses.forEach((response) => {
        if (response?.message) {
          dispatch(resetDataComponent("ordersGrid"));
          showMessage(response.message, response.success ? "success" : "error");
        }
      });
    } catch (e: any) {
      showMessage(e.error);
    } finally {
      setBulkOrderID(null);
    }
  };

  const saveData = async (data: any) => {
    const request: any = {
      newStatus: data?.newStatus,
      updatedBy: "Test"
    };

    const response: any = await callAPI(
      `orders/${orderId}/status`,
      Method.PUT,
      request
    );
    return response;
  };
  const handleCloseDialog = (data?: any) => {
    setOrderID(null);
    setBulkOrderID(null);
  };
  useEffect(() => {
    if (orderId) {
      openPopUp(metadataStatus, handleStatus, "40rem", handleCloseDialog);
    }
  }, [orderId]);

  useEffect(() => {
    if (bulkOrderId) {
      openPopUp(metadataStatus, handleBulkStatus, "40rem", handleCloseDialog);
    }
  }, [bulkOrderId]);

  const metadataStatus: IMetaData = {
    title: "Update Status",
    hideActions: false,
    content: (props: any, row: any) => <UpdateStatus {...props} />,
    actions: [
      {
        label: "Cancel",
        // onClick: handleCloseDialog,
        className: "ws-cancel",
        type: "button"
      },
      {
        label: "Submit",
        onClick: handleStatus,
        type: "submit",
        autoFocus: true
      }
    ],
    isDragable: true
  };
  const handleAction = async (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/new-walk-in-order/${row?.orderId}`);
    } else if (action === "Delete") {
      setSelectedId(row?.orderId);
      setPopupOpen(true);
    } else if (action === "Change Status") {
      setOrderID(row?.orderId);
    } else if (action === "Print Tag") {
      setLoading(true);
      try {
        const response: any = await callAPI(
          "orders",
          Method.GET,
          null,
          row?.orderId
        );

        if (response && response?.data) {
          const order = response.data;

          // Transform data to match `PrintData` format
          const formattedData: PrintData = {
            orderNumber: order.orderNumber,
            customerName: order.customerName,
            orderItems: order.orderItems.map((item: any) => ({
              productId: item.productId,
              productName: item.productName,
              serviceName: item.serviceName,
              quantity: item.quantity,
              itemTag: item.itemTag
            }))
          };

          // setPrintData(formattedData);
          handlePrint(formattedData);
        }
      } catch (error) {
        console.error("Failed to retrieve data", error);
        showMessage("Something went wrong. Please try again.", "error");
      } finally {
        setLoading(false);
      }
      // setQRCodevalue(row?.orderNumber);
    } else if (action === "Generate Bill") {
      setLoading(true);
      try {
        const response: any = await callAPI(
          "orders",
          Method.GET,
          null,
          row?.orderId
        );

        if (response && response?.data) {
          const bill = response.data;

          const printWindow = window.open("", "_blank", "width=800,height=600");

          const orderRows = bill.orderItems
            .map((item: any, index: number) => {
              const isWeighted = item.weight !== null && item.weight > 0;
              return `
      <tr>
        <td>${index + 1}</td>
        <td>${item.productName} ${isWeighted ? "(Laundry by weight)" : ""}</td>
         <td>${item.isWeighted ? "—" : item.quantity}</td>
        <td>${item.price}</td>
        <td>${isWeighted ? item.price : item.quantity * item.price}</td>
      </tr>
    `;
            })
            .join("");

          const totalQuantity = bill.orderItems.reduce(
            (sum: number, item: any) => sum + item.quantity,
            0
          );

          printWindow?.document.write(`
  <html>
    <head>
      <title>Receipt</title>
      <style>
        @media print {
          body {
            font-family: Arial, sans-serif;
            font-size: 18px;
            margin: 0;
            padding: 0;
          }

           .print-receipt {
            width: 80mm;
            max-width: 80mm;
            margin: auto;
            padding: 4px;
          }

          .logo {
            text-align: center;
            margin-bottom: 4px;
          }

          .logo h1 {
            font-size: 21px;
            margin: 0;
            font-weight: bold;
          }

          .logo h2 {
            font-size: 19px;
            margin: 2px 0;
            font-weight: normal;
          }

          .company-details {
            text-align: center;
            font-size: 18px;
            margin-bottom: 4px;
          }

          .container {
            display: flex;
            justify-content: left;
            font-size: 18px;
            padding-bottom: 4px;
          }

          thead{
          border-bottom: 1px solid #000;
          }

          .section {
            flex: 1;
            padding: 2px;
          }

          .section p {
            margin: 2px 0;
          }

          .invoice {
  text-align: center;
  font-size: 21px;
  margin-bottom: 5px;
}

          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 12px;
          }

          table th, table td {
            padding: 3px;
            text-align: left;
          }

         
          .summary {
            display: flex;
            justify-content: space-between;
            font-weight: bold;
            font-size: 14px;
            margin-top: 6px;
          }

          .terms p {
            font-size: 10px;
            margin: 2px 0;
          }

          .thank-you {
            text-align: center;
            margin-top: 8px;
            font-size: 14px;
            font-weight: bold;
          }
        }
      </style>
    </head>
    <body>
      <div class="print-receipt">
        
        <div class="logo">
  <h1>${company?.name || "3 FOLD"}</h1>
  <h2>Laundry & Dry Cleaners</h2>
</div>

<div class="company-details">
  <p>Email: www.3foldlaundry.com</p>
  <p>Phone: ${company?.contactNumber || "9072512525"}</p>
  <p>Address: ${company?.addressLine1}, ${company?.addressLine2}, ${
            company?.city
          }, ${company?.state} - ${company?.pincode}</p>
</div>

       <div class="invoice">
  <p><strong>Invoice:</strong> ${bill.orderNumber}</p>
</div>

<div class="container">
  
  <div class="section">
   <p><strong>Date:</strong> ${new Date(
     bill.orderDate
   ).toLocaleDateString()}</p>
    <p><strong>Customer Name:</strong> ${bill.customerName}</p>
    <p><strong>Phone Number:</strong> ${bill.phoneNumber}</p>
  </div>
</div>


        <hr/>

        <div class="section">
          <p><strong>Order Items:</strong></p>
          
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Product</th>
                <th>Qty</th>
                <th>Price (₹)</th>
                <th>Amount (₹)</th>
              </tr>
            </thead>
            <tbody>
              ${orderRows}
            </tbody>
          </table>
        </div>

        <div class="summary">
          <div>Total Qty: ${totalQuantity}</div>
          <div>Total Amount: ₹${bill.finalAmount}</div>
        </div>

        <hr/>

        <div class="terms">
          <p><strong>Terms & Conditions</strong></p>
          <p>1. Check articles for damage at delivery & report within 24 hrs.</p>
          <p>2. Not responsible for shrinkage, discoloration, unseen defects.</p>
          <p>3. Articles left 15+ days may incur extra charges or disposal.</p>
          <p>4. Stain removal is not guaranteed; cleaned at owner’s risk.</p>
          <p>5. Max compensation: ₹3,000 or 6x cleaning cost.</p>
          <p>6. Claims on washing quality must be within 2 days of delivery.</p>
        </div>

        <div class="terms">
          <p><strong>Compensation & Disclaimer</strong></p>
          <p>1. Not responsible for personal items left in garments.</p>
          <p>2. We reserve the right to refuse cleaning certain garments.</p>
          <p>3. Not liable for losses due to fire, burglary, or unforeseen events.</p>
          <p>4. No refunds for delays; extra processing time may be needed.</p>
        </div>

        <div class="section" style="text-align:center;">
          <p>Please check your bill before leaving the store</p>
        </div>

        <div class="thank-you">
          Thank You, Come Again!
        </div>
      </div>
    </body>
  </html>
`);

          printWindow?.document.close();
          printWindow?.focus();
          printWindow?.print();
        }
      } catch (error) {
        console.error("Failed to retrieve data", error);
        showMessage("Something went wrong. Please try again.", "error");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleDelete = () => {
    dispatch(resetDataComponent("ordersGrid"));
    showMessage("Order deleted successfully!", "success");
  };

  const handleBulkAction = async (actionType: string) => {
    if (selectedOrderIds.length === 0) {
      alert("No orders selected!");
      return;
    }

    if (actionType === "Edit") {
      if (selectedOrderIds.length === 1) {
        navigate(`/new-walk-in-order/${selectedOrderIds[0].orderId}`);
      } else {
        alert("You can only edit one order at a time.");
      }
    } else if (actionType === "Delete") {
      if (selectedOrderIds.length === 1) {
        setSelectedId(selectedOrderIds[0].orderId);
        setPopupOpen(true);
      } else {
        alert("You can only delete one order at a time, right now.");
      }
    }
    // else if (actionType === "Change Status") {
    //   setBulkOrderID(selectedOrderIds); // assuming setOrderID accepts string[]
    // }
    else if (["Completed", "Processing", "Delivered"].includes(actionType)) {
      await handleBulkStatus({ newStatus: actionType });
    } else if (actionType === "Print Tag") {
      if (selectedOrderIds.length > 0) {
        setLoading(true);
        try {
          for (const order of selectedOrderIds) {
            const response: any = await callAPI(
              "orders",
              Method.GET,
              null,
              order.orderId // Use the correct order object
            );

            if (response?.data) {
              const orderData = response.data;

              const formattedData: PrintData = {
                orderNumber: orderData.orderNumber,
                customerName: orderData.customerName,
                orderItems: orderData.orderItems.map((item: any) => ({
                  productId: item.productId,
                  productName: item.productName,
                  serviceName: item.serviceName,
                  quantity: item.quantity,
                  itemTag: item.itemTag
                }))
              };

              handlePrint(formattedData);
            }
          }
        } catch (error) {
          console.error("Failed to retrieve order data", error);
          showMessage("Something went wrong. Please try again.", "error");
        } finally {
          setLoading(false);
        }
      } else {
        alert("No orders selected to print.");
      }
    } else if (actionType === "Generate Bill") {
      if (selectedOrderIds.length > 0) {
        for (const orderId of selectedOrderIds) {
          try {
            const response: any = await callAPI(
              "orders",
              Method.GET,
              null,
              orderId.orderId
            );

            if (response && response?.data) {
              const bill = response.data;

              const printWindow = window.open(
                "",
                "_blank",
                "width=800,height=600"
              );

              const orderRows = bill.orderItems
                .map((item: any, index: number) => {
                  const isWeighted = item.weight !== null && item.weight > 0;
                  return `
        <tr>
          <td>${index + 1}</td>
          <td>${item.productName} ${
                    isWeighted ? "(Laundry by weight)" : ""
                  }</td>
           <td>${item.isWeighted ? "—" : item.quantity}</td>
          <td>${item.price}</td>
          <td>${isWeighted ? item.price : item.quantity * item.price}</td>
        </tr>
      `;
                })
                .join("");

              const totalQuantity = bill.orderItems.reduce(
                (sum: number, item: any) => sum + item.quantity,
                0
              );

              printWindow?.document.write(`
      <html>
        <head>
          <title>Receipt</title>
          <style>
            @media print {
              body {
                font-family: Arial, sans-serif;
                font-size: 18px;
                margin: 0;
                padding: 0;
              }
    
               .print-receipt {
                width: 80mm;
                max-width: 80mm;
                margin: auto;
                padding: 4px;
              }
    
              .logo {
                text-align: center;
                margin-bottom: 4px;
              }
    
              .logo h1 {
                font-size: 21px;
                margin: 0;
                font-weight: bold;
              }
    
              .logo h2 {
                font-size: 19px;
                margin: 2px 0;
                font-weight: normal;
              }
    
              .company-details {
                text-align: center;
                font-size: 18px;
                margin-bottom: 4px;
              }
    
              .container {
                display: flex;
                justify-content: left;
                font-size: 18px;
                padding-bottom: 4px;
              }
    
              thead{
              border-bottom: 1px solid #000;
              }
    
              .section {
                flex: 1;
                padding: 2px;
              }
    
              .section p {
                margin: 2px 0;
              }
    
              .invoice {
      text-align: center;
      font-size: 21px;
      margin-bottom: 5px;
    }
    
              table {
                width: 100%;
                border-collapse: collapse;
                font-size: 12px;
              }
    
              table th, table td {
                padding: 3px;
                text-align: left;
              }
    
             
              .summary {
                display: flex;
                justify-content: space-between;
                font-weight: bold;
                font-size: 14px;
                margin-top: 6px;
              }
    
              .terms p {
                font-size: 10px;
                margin: 2px 0;
              }
    
              .thank-you {
                text-align: center;
                margin-top: 8px;
                font-size: 14px;
                font-weight: bold;
              }
            }
          </style>
        </head>
        <body>
          <div class="print-receipt">
            
            <div class="logo">
  <h1>${company?.name || "3 FOLD"}</h1>
  <h2>Laundry & Dry Cleaners</h2>
</div>

<div class="company-details">
  <p>Email: "www.3foldlaundry.com"</p>
  <p>Phone: ${company?.contactNumber || "9072512525"}</p>
  <p>Address: ${company?.addressLine1}, ${company?.addressLine2}, ${
                company?.city
              }, ${company?.state} - ${company?.pincode}</p>
</div>

    
           <div class="invoice">
      <p><strong>Invoice:</strong> ${bill.orderNumber}</p>
    </div>
    
    <div class="container">
      
      <div class="section">
       <p><strong>Date:</strong> ${new Date(
         bill.orderDate
       ).toLocaleDateString()}</p>
        <p><strong>Customer Name:</strong> ${bill.customerName}</p>
        <p><strong>Phone Number:</strong> ${bill.phoneNumber}</p>
      </div>
    </div>
    
    
            <hr/>
    
            <div class="section">
              <p><strong>Order Items:</strong></p>
              <table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Product</th>
                    <th>Qty</th>
                    <th>Price (₹)</th>
                    <th>Amount (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  ${orderRows}
                </tbody>
              </table>
            </div>
    
            <div class="summary">
              <div>Total Qty: ${totalQuantity}</div>
              <div>Total Amount: ₹${bill.finalAmount}</div>
            </div>
    
            <hr/>
    
            <div class="terms">
              <p><strong>Terms & Conditions</strong></p>
              <p>1. Check articles for damage at delivery & report within 24 hrs.</p>
              <p>2. Not responsible for shrinkage, discoloration, unseen defects.</p>
              <p>3. Articles left 15+ days may incur extra charges or disposal.</p>
              <p>4. Stain removal is not guaranteed; cleaned at owner’s risk.</p>
              <p>5. Max compensation: ₹3,000 or 6x cleaning cost.</p>
              <p>6. Claims on washing quality must be within 2 days of delivery.</p>
            </div>
    
            <div class="terms">
              <p><strong>Compensation & Disclaimer</strong></p>
              <p>1. Not responsible for personal items left in garments.</p>
              <p>2. We reserve the right to refuse cleaning certain garments.</p>
              <p>3. Not liable for losses due to fire, burglary, or unforeseen events.</p>
              <p>4. No refunds for delays; extra processing time may be needed.</p>
            </div>
    
            <div class="section" style="text-align:center;">
              <p>Please check your bill before leaving the store</p>
            </div>
    
            <div class="thank-you">
              Thank You, Come Again!
            </div>
          </div>
        </body>
      </html>
    `);

              printWindow?.document.close();
              printWindow?.focus();
              printWindow?.print();
            }
          } catch (error) {
            console.error("Failed to retrieve data and genreate bill", error);
            showMessage("Something went wrong. Please try again.", "error");
          } finally {
            setLoading(false);
          }
        }
      } else {
        alert("No orders selected to generate bills.");
      }
    }
  };
  const handlePrint = (printData: PrintData) => {
    if (!printData || !printData.orderItems) return;

    const expandedItems = printData.orderItems.flatMap((item) =>
      Array.from({ length: item.quantity }, () => item)
    );

    // Open a single print window
    const printWindow = window.open("", "_blank", "width=600,height=400");
    if (printWindow) {
      const applyMargin = franchiseId === "f98f89ab-c91e-4558-be99-6698fa93b738";
      printWindow.document.write(`
        <html>
          <head>
            <title>Print Tags</title>
            <style>
              body { 
                font-family: Arial, sans-serif; 
                padding: 0; 
                margin: 0; 
              }
      
              .tag-container { 
          text-align: center; 
          width: 170px;
          height: 200px;
          display: flex;
          flex-direction: column;
          justify-content: ${applyMargin ? "flex-start" : "center"};
          align-items: ${applyMargin ? "flex-start" : "center"};
          line-height: 1.5;
          ${applyMargin ? "margin-right: 14px; padding-top: 10px;" : ""}
        }
      
              .tag-title {
                font-size: 14px;
                font-weight: bold;
                margin: 0;
                padding: 0;
              }
      
              p {
                font-size: 14px;
                margin: 2px 0;
              }
      
              @media print {
                body {
                  display: block;
                }
              }
            </style>
          </head>
          <body>
      `);

      expandedItems.forEach((item, index) => {
        printWindow.document.write(`
            <div class="tag-container">
                <p class="tag-title">3 Fold ${company?.city}</p>
                <p>${printData.customerName}</p>
                <p>${new Date().toLocaleDateString()}</p>
                <span style="font-size:15px; font-weight: bold;">#${
                  printData.orderNumber
                }</span>
                <p style="margin-top:4px; margin-bottom:3px">${
                  item.serviceName
                }</p>
                <p>${item.productName}</p>
                <p>T ${expandedItems.length}</p>
            </div>
            ${
              index !== expandedItems.length - 1
                ? '<div style="page-break-after: always;"></div>'
                : ""
            }
        `);
      });

      printWindow.document.write(`</body></html>`);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
    }
  };

  const bulkActions: BulkAction[] = [
    {
      label: "Edit",
      icon: <WSIcons.Edit />,
      color: "#4CAF50",
      onClick: () => handleBulkAction("Edit")
    },
    {
      label: "Delete",
      icon: <WSIcons.Delete />,
      color: "#FF6B6B",
      onClick: () => handleBulkAction("Delete")
    },
    {
      label: "Print Tag",
      icon: <WSIcons.Print />,
      color: "#FFD700",
      onClick: () => handleBulkAction("Print Tag")
    },
    {
      label: "Generate Bill",
      icon: <WSIcons.ReceiptIcon />,
      color: "#3D52A0",
      onClick: () => handleBulkAction("Generate Bill")
    },
    // {
    //   label: "Change Status",
    //   icon: <WSIcons.SyncIcon />,
    //   color: "#FF9800",
    //   onClick: () => handleBulkAction("Change Status")
    // }
    {
      label: "Completed",
      icon: <WSIcons.CheckIcon />,
      color: "#4CAF50",
      onClick: () => handleBulkAction("Completed")
    },
    {
      label: "Processing",
      icon: <WSIcons.SyncIcon />,
      color: "#FFA726",
      onClick: () => handleBulkAction("Processing")
    },
    {
      label: "Delivered",
      icon: <WSIcons.LocalShippingIcon />,
      color: "#03A9F4",
      onClick: () => handleBulkAction("Delivered")
    }
  ];

  const handleSelectedOrderIds = (selectedOrders: Order[]) => {
    setSelectedOrderIds(selectedOrders);
  };

  return (
    <>
      {/* actions={[{
        type: 'filter', filterFields: filterRows, text: 'aa', onFilterChange(data) {
          handleFilterChange(data)
        },
      }]} */}
      <HeaderList
        title="Orders"
        type="card"
        info={`${totalCount || 0} Total Records`}
      />
      {view ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <WSDataGrid
              id="ordersGrid"
              title="Orders"
              headerType="simple"
              columns={columns}
              filterFields={filterRows}
              source={source}
              transFormData={transFormData}
              isFilterChanged={filterChanged}
              searchBox={{
                fieldName: "PhoneNumber",
                bg: "white"
              }}
              placeholder={"Search by Phone Number"}
              exportCsv={exports}
              addButton={add ? { label: "", color: "secondary" } : undefined}
              onAddButtonClick={handleClick}
              columnAction
              bulkActions={bulkActions}
              handleCheckBoxChangedValues={handleSelectedOrderIds} // Pass the handler to get selected order IDs
            />
          </Grid>
        </Grid>
      ) : (
        <PermissionDenied />
      )}
      {/* {qrcodeValue && (
        <TagPrint
          printRef={printRef}
          onPrint={handlePrint}
          value={qrcodeValue}
        />
      )} */}
      <LoadingOverlay loading={loading} />
      {selectedId !== null && (
        <ConfirmationPopup
          apiUrl={"orders"}
          id={selectedId}
          confirmMessage="Are you sure you want to delete this order?"
          open={isPopupOpen}
          onClose={() => setPopupOpen(false)}
          onConfirm={handleDelete}
          permanent
        />
      )}
    </>
  );
};

// before print
// .print-receipt {
//   width: 80mm;
//   max-width: 80mm;
//   margin: auto;
//   padding: 4px;
// }

//after with min

// .print-receipt {
//   width: 100%;
//   max-width: 80mm;
//   min-width: 100%;
//   margin: auto;
//   padding: 4px;
// }
